import PoiDescriptionCreate from "src/resources/poi-descriptions/PoiDescriptionCreate"
import PoiDescriptionEdit from "src/resources/poi-descriptions/PoiDescriptionEdit"

const resource = {
  create: PoiDescriptionCreate,
  edit: PoiDescriptionEdit,
}

export default resource
